import { Location } from 'react-router-dom';

type Breadcrumb = { label: string; path?: string };

const routeLabels: Record<string, string> = {
	// Admin - Acceso
	users: 'Usuarios',
	groups: 'Grupos',

	// Admin - Gestión
	projects: 'Proyectos',
	opportunities: 'Oportunidades',

	// Admin - Vacaciones
	dayOffRequests: 'Solicitudes de vacaciones',
	daysOffBalance: 'Balance de vacaciones',
	daysOffConfiguration: 'Configuración de vacaciones',

	// Admin - Registro
	workActivityTypes: 'Tipos de actividad',
	workAnalytics: 'Carga de trabajo',
	timesheet: 'Registro horario',

	// Admin - Configuration
	'settings-google': 'Ajustes Google',
	'settings-days-off': 'Días libres',
	'settings-holidays': 'Festivos',

	// Web CMS
	webClients: 'Clientes',
	webCategories: 'Categorías',
	webCredentials: 'Credenciales',
	webPrivate: 'Web Privada',

	// Worker
	dayoff: 'Vacaciones',
	'user-timesheet': 'Registro horario',
	'user-config': 'Configuración',

	// Actions
	new: 'Nuevo',
	edit: 'Editar',
	archived: 'Archivados',
	daysOff: 'Vacaciones',
	print: 'Imprimir',
};

export const generateAdminBreadcrumbs = (location: Location): Breadcrumb[] => {
	const segments = location.pathname.split('/').filter((x) => x);
	if (segments.length === 0) return [];

	const breadcrumbs: Breadcrumb[] = [{ label: 'Inicio', path: '/' }];

	segments.forEach((segment, index) => {
		const path = `/${segments.slice(0, index + 1).join('/')}`;
		const isLast = index === segments.length - 1;
		const label = routeLabels[segment];

		if (!label) return; // Skip dynamic segments (IDs)

		breadcrumbs.push({
			label,
			path: isLast ? undefined : path,
		});
	});

	return breadcrumbs;
};
